import { Component } from '@angular/core';
import { FilterService } from './filter.service';

@Component({
  selector: 'forms-report-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})

export class FilterComponent {
  constructor(public readonly filterService: FilterService) {  }
}
